import { render, staticRenderFns } from "./DChangePermissionConfirmation.vue?vue&type=template&id=766cb71a&scoped=true&"
import script from "./DChangePermissionConfirmation.vue?vue&type=script&lang=js&"
export * from "./DChangePermissionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DChangePermissionConfirmation.vue?vue&type=style&index=0&id=766cb71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766cb71a",
  null
  
)

export default component.exports